<div class="flex min-h-full flex-col justify-center py-12 px-5 sm:px-6 lg:px-8">
  <div class="sm:mx-auto sm:w-full sm:max-w-md">
    <img [src]="environment.primaryIconPath" class="mx-auto h-40 w-auto">
    <h2 class="mt-6 text-center text-2xl font-bold leading-9 tracking-tight text-gray-900">{{ mode === 'resetPassword' && newPassForm ? 'Reset Password' : errors ? 'An Error Occurred' : isLoaded ? 'Successfully Verified Email' : 'Please Wait'}}</h2>
  </div>

  <div class="mt-10 sm:mx-auto sm:w-full sm:max-w-[480px]">
    <div class="bg-white px-6 py-12 shadow rounded-lg sm:px-12">
      <ng-container *ngIf="mode === 'verifyEmail'">
        <div class="w-full h-full flex flex-row items-center justify-center">
          <tandem-loading-container [isLoaded]="isLoaded">
            <div class="w-full">
              <h4 class="text-lg" *ngIf="!errors">Thanks for verifying your email! Your account is now verified and ready to use. You can close this tab and return to the platform.</h4>
              <h4 *ngIf="errors" class="text-red text-lg">Oh no! {{errors}}</h4>
            </div>
          </tandem-loading-container>
        </div>

      </ng-container>
      <ng-container *ngIf="mode === 'resetPassword' && newPassForm">
        <form class="space-y-6">
          <div>
            <label for="newPassword" class="block text-sm font-medium leading-6 text-gray-900">New Password</label>
            <div class="mt-2">
              <input id="newPassword"
                     name="newPassword"
                     type="password"
                     autocomplete="new-password"
                     required
                     [formControl]="getFormControl()"
                     class="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6">
              <div *ngIf="newPassForm.get('newPassword')?.invalid && newPassForm.get('newPassword')?.touched" class="mt-2 text-sm text-red-600">
                <div *ngIf="newPassForm.get('newPassword')?.errors?.['required']">Password is required.</div>
                <div *ngIf="newPassForm.get('newPassword')?.errors?.['minlength']">Password must be at least 8 characters long.</div>
                <div *ngIf="newPassForm.get('newPassword')?.errors?.['pattern']">Password must contain at least one capital letter and one special character (!@#$%^&*).</div>
              </div>
            </div>
          </div>
          <div>
            <tandem-button theme="solid" color="primary" [disabled]="newPassForm.invalid" [onClick]="saveNewPassword.bind(this)">Reset Password</tandem-button>
          </div>
        </form>
      </ng-container>
    </div>
  </div>
</div>
